// extracted by mini-css-extract-plugin
export var buttonIconWrapper = "_9j-4";
export var collapsed = "_9j-1";
export var headerBar = "_9j-0";
export var leftHeaderContent = "_9j-3";
export var subjectContainer = "_9j-2";